import { useCallback, useLayoutEffect, useState } from 'react'

import InterWebviewBridge, {
  IWbAppInfo,
  interWbSession,
  WbEnvironments,
} from '@interco/inter-webview-bridge'

import { appInfoMock } from '../mocks/appInfo'

export const useAppInfo = () => {
  const [appInfo, setAppInfo] = useState<IWbAppInfo>({} as IWbAppInfo)

  const interWb = InterWebviewBridge.getInstance()

  const getAppInfo = useCallback(async () => {
    const isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    const isMock =
      isDev &&
      (process.env.REACT_APP_MOCK_ENABLED === 'true' ||
        interWb.getEnvironment() === WbEnvironments.BROWSER)

    if (isMock) {
      setAppInfo(appInfoMock)
    } else {
      const data = await interWbSession.getAppInfo()
      setAppInfo(data)
    }
  }, [interWb])

  useLayoutEffect(() => {
    getAppInfo()
  }, [getAppInfo])

  return appInfo
}
